import { put, takeLatest, select } from 'redux-saga/effects';
import types from './types';
import actions from './actions';
import ktRequest from '../../../utils/request';

const getCurrentCenterId = state => state.identity.centerId;

function * getPhotosForMonth (payload) {
  try {
    const { month, year } = payload;
    const centerId = yield select(getCurrentCenterId);
    const { data } = yield ktRequest.get(`gallery/by-month/center/${centerId}?month=${month}&year=${year}`, 'gallery');

    yield put(actions.getPhotosForMonthSuccess(data, month, year));
  } catch (error) {
    console.log(error);
    yield put(actions.getPhotosForMonthFailure());
  }
}

export const centerGallerySagas = [
  takeLatest(types.GET_CENTER_PHOTOS_MONTH_REQUEST, getPhotosForMonth)
];
